import React from "react";
import "./Messages.css";
import ScrollBottom from "react-scroll-to-bottom";
import Message from "./Message/Message";

const Messages = ({ messages, name }) => {
  return (
    <ScrollBottom className="messages">
      {messages.map((msg, i) => (
        <div key={i}>
          <Message message={msg} name={name} />
        </div>
      ))}
    </ScrollBottom>
  );
};

export default Messages;
